import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { catchError, first, map, of } from "rxjs";

/**
 * Guard for canMatch - route only matches if user is authenticated.
 * Use to conditionally match routes based on auth state.
 */
export const isAuthenticatedMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated().pipe(
    first(),
    // Never let the guard error: an errored canMatch aborts route matching and
    // leaves a blank page. A failed auth check means "not authenticated".
    catchError(() => of(false)),
  );
};

/**
 * Guard for canMatch - route only matches if user is NOT authenticated.
 */
export const isNotAuthenticatedMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated().pipe(
    first(),
    map((isAuth) => !isAuth),
    // A failed auth check means "not authenticated", so the login route should
    // match rather than the navigation blowing up.
    catchError(() => of(true)),
  );
};
